import { render, staticRenderFns } from "./GroupsPushFault.vue?vue&type=template&id=6c48e713&"
import script from "./GroupsPushFault.vue?vue&type=script&lang=ts&"
export * from "./GroupsPushFault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports